import React from 'react';
import { observer } from 'mobx-react-lite';

import useAuth from 'hooks/useAuth';
import useUserIdentity from 'hooks/useUserIdentity';

type AssistantOnlyProps = {
    children?: React.ReactNode;
    allowClient?: boolean;
    allowIC?: boolean;
};

// Render children for assistants. Clients only see the children when
// `allowClient` is set; ICs only when `allowIC` is set.
const AssistantOnly = observer(({ children, allowClient = false, allowIC = false }: AssistantOnlyProps) => {
    const { currentUser } = useAuth();
    const { currentIdentity } = useUserIdentity();

    if (!currentUser || !currentIdentity)
        return null;

    if (currentIdentity.role == 'client')
        return allowClient ? <>{children}</> : null;

    if (currentUser.is_ic)
        return allowIC ? <>{children}</> : null;

    return <>{children}</>;
});

export default AssistantOnly;
